import { Skeleton } from '@/components/Skeleton/Skeleton';

/**
 * Loading placeholder rows for admin tables — shown on every page change /
 * filter refetch (ADR-056) instead of an empty tbody, so the table keeps
 * its height and the user sees the page is working.
 */
export function AdminTableSkeletonRows({ columns, rows = 5 }: { columns: number; rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, index) => (
        <tr key={index} className="admin-table__skeleton-row">
          <td colSpan={columns}>
            <Skeleton height={18} />
          </td>
        </tr>
      ))}
    </>
  );
}
